export default __webpack_public_path__ + "static/media/Local Expertise.1d7dbbac.svg";